import axios from "../../utils/axios";

export const getBlog = async (blogId) => {
    const response = await axios.get(`/blogs/${blogId}`);
    return response.data;
};
